import { render, staticRenderFns } from "./policiesandregulations.vue?vue&type=template&id=68babc05&scoped=true&"
import script from "./policiesandregulations.vue?vue&type=script&lang=js&"
export * from "./policiesandregulations.vue?vue&type=script&lang=js&"
import style0 from "./policiesandregulations.vue?vue&type=style&index=0&id=68babc05&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68babc05",
  null
  
)

export default component.exports